import { createContext } from 'react';
import type { UserProfileSnapshot } from '@/lib/profile';

export const ProfileContext = createContext<UserProfileSnapshot | null>(null);
